import React from "react";
import dayjs from "dayjs";

import { Steps, Card, Typography, Row, Col } from "antd";
const { Step } = Steps;
const { Text } = Typography;

const TrackingData = ({ dataOrder }) => {
  const tglPenugasan = dayjs(dataOrder.create_date);

  const cutOffNotice = dayjs("2024-04-28");
  const cutOffJasa = dayjs("2022-03-22");

  let parallelSteps, sortedParallelSteps;

  let allSteps = [
    {
      title: "Order Masuk",
      description: `Kode Order ${dataOrder.order_code}`,
      timestamp: dataOrder.order_closing_date,
    },
    {
      title: "Penugasan ke Biro Jasa",
      description: `Biro ${dataOrder.service_bureau_name}`,
      timestamp: dataOrder.create_date,
    },
    {
      title: "Tagihan di Upload",
      description: `No tagihan ${dataOrder.invoice_number}`,
      timestamp: dataOrder.transfer_title_date,
    },
  ];

  if (tglPenugasan.isAfter(cutOffNotice) || dataOrder.vehicle_notice_data !== undefined) {
    parallelSteps = [
      {
        title: "Notice di Bayar",
        description: (
          <>
            Status {dataOrder.bill_notice_status}
            <br />
            Nominal Bayar {dataOrder?.notice_cost?.toLocaleString()}
          </>
        ),
        timestamp: dataOrder.bill_notice_generated_date,
        status: dataOrder.bill_notice_status,
      },
      {
        title: "PKB di Bayar",
        description: (
          <>
            Status {dataOrder.bill_pkb_status}
            <br />
            No Tagihan {dataOrder.bill_pkb_invoice_number}
            <br />
            Nominal Bayar {dataOrder?.pkb_cost?.toLocaleString()}
            {dataOrder.bill_pkb_invoice_number !== "PAID_BY_NOTICE" && (
              <>
                <br />
                Tgl Penagihan {dataOrder.bill_pkb_invoice_number === "PAID_BY_NOTICE" ? dataOrder.bill_notice_generated_date : dataOrder.bill_pkb_paid_date}
                <br />
                ID Bill {dataOrder?.bill_pkb_id_bill}
                <br />
                Remarks1 {dataOrder?.bill_pkb_bill_detail?.Remarks1}
                <br />
                Remarks2 {dataOrder?.bill_pkb_bill_detail?.Remarks2}
              </>
            )}
          </>
        ),
        timestamp: dataOrder.bill_pkb_invoice_number === "PAID_BY_NOTICE" ? dataOrder.bill_notice_generated_date : dataOrder.bill_pkb_paid_date,
        status: dataOrder.bill_pkb_status,
      },
      {
        title: "Tagihan Biaya Proses di Kirim",
        description: (
          <>
            No Tagihan {dataOrder?.bill_process_cost_invoice_number}
            <br />
            Nominal Bayar {dataOrder?.process_cost?.toLocaleString()}
            <br />
            ID Bill {dataOrder?.bill_process_cost_id_bill}
          </>
        ),
        timestamp: dataOrder.bill_process_cost_submitted_date,
        status: dataOrder.bill_process_cost_status,
      },
      {
        title: "Biaya Proses di Bayar",
        description: (
          <>
            Status {dataOrder.bill_process_cost_status}
            <br />
            Remarks1 {dataOrder?.bill_process_cost_bill_detail[0]?.Remarks1}
            <br />
            Remarks2 {dataOrder?.bill_process_cost_bill_detail[0]?.Remarks2}
          </>
        ),
        timestamp: dataOrder.bill_process_cost_paid_date,
        status: dataOrder.bill_process_cost_status,
      },
    ];

    sortedParallelSteps = [...parallelSteps].sort((a, b) => {
      const hasA = !!a.timestamp;
      const hasB = !!b.timestamp;

      // Jika salah satu tidak ada timestamp
      if (!hasA && hasB) return 1; // a > b → a di belakang
      if (hasA && !hasB) return -1; // a < b → a di depan

      // Dua-duanya tidak punya timestamp → biarkan urutannya
      if (!hasA && !hasB) return 0;

      // Dua-duanya punya timestamp → urutkan berdasarkan waktu
      return new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime();
    });

    allSteps = [
      ...allSteps,
      {
        title: "Notice di Upload",
        description: `No Notice ${dataOrder?.vehicle_notice_data?.no_notice}`,
        timestamp: dataOrder.vehicle_notice_entry_date,
      },
      {
        title: "Progresif di Bayar",
        description: (
          <>
            Status {dataOrder.bill_progressive_status}
            <br />
            Nominal Bayar {dataOrder?.progressive_cost?.toLocaleString()}
          </>
        ),
        timestamp: dataOrder.bill_progressive_detail.qris_paid_time || (dataOrder.bill_progressive_status === "NONE" ? dataOrder.vehicle_notice_entry_date : undefined),
        status: dataOrder.bill_progressive_status,
      },
      ...sortedParallelSteps,
    ];
  } else {
    if (dataOrder.transfer_title_status === "GENERATED") {
      allSteps = [
        ...allSteps,
        {
          title: "Tagihan Dibayar",
          description: `Total Tagihan ${dataOrder?.transfer_title_cost?.toLocaleString()}`,
          timestamp: dataOrder.old_paid_date,
          status: dataOrder.transfer_title_status,
        },
      ];
    }
  }

  if (tglPenugasan.isAfter(cutOffJasa) || dataOrder.service_cost > 0) {
    allSteps = [
      ...allSteps,
      {
        title: "Tagihan Biaya Jasa di Kirim",
        description: (
          <>
            No Tagihan {dataOrder?.bill_service_cost_invoice_number}
            <br />
            Nominal Bayar {dataOrder?.service_cost?.toLocaleString()}
            <br />
            ID Bill {dataOrder?.bill_service_cost_id}
          </>
        ),
        timestamp: dataOrder.bill_service_cost_submitted_date,
        status: dataOrder.bill_service_cost_status,
      },
      {
        title: "Biaya Jasa di Bayar",
        description: (
          <>
            Status {dataOrder.bill_service_cost_status}
            <br />
            Remarks1 {dataOrder?.bill_service_cost_bill_detail?.Remarks1}
            <br />
            Remarks2 {dataOrder?.bill_service_cost_bill_detail?.Remarks2}
          </>
        ),
        timestamp: dataOrder.bill_service_cost_paid_date,
        status: dataOrder.bill_service_cost_status,
      },
    ];
  }

  // 2. Tentukan current step index (langkah terakhir dengan timestamp !== null)
  const isValidTimestamp = (ts) => {
    if (!ts) return false;
    if (typeof ts !== "string") return true; // misal: Date object
    return ts.trim().toLowerCase() !== "none";
  };

  const currentStep = allSteps.reduce((lastIdx, step, index) => {
    return isValidTimestamp(step.timestamp) || step.status === "PAID" || step === "GENERATED" ? index : lastIdx;
  }, +1);

  const cardTitle = (
    <>
      <Row justify="space-between" align="middle" style={{ paddingTop: 10, paddingBottom: 10 }}>
        <Col>
          <Text strong style={{ fontSize: 16 }}>
            {dataOrder.customer_doc_name}
          </Text>
          <br />
          <Text type="secondary">{dataOrder.order_code}</Text>
          <br />
          <Text type="secondary"></Text>
        </Col>
        <Col style={{ textAlign: "right" }}>
          <Text type="secondary">TAGIHAN {dataOrder.invoice_number}</Text>
          <br />
          <Text strong style={{ fontSize: 16 }}>
            BIRO {dataOrder.service_bureau_code} - {dataOrder.service_bureau_account_number}
          </Text>
        </Col>
      </Row>
    </>
  );

  return (
    <Card title={cardTitle}>
      <Row justify="space-between" align="middle">
        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
          <Row>
            <Col span={10}>No Polisi</Col>
            <Col span={14}>:&nbsp;{dataOrder.vehicle_license_plate}</Col>
          </Row>
          <Row>
            <Col span={10}>Nomor Mesin</Col>
            <Col span={14}>:&nbsp;{dataOrder.vehicle_engine_number}</Col>
          </Row>
          <Row>
            <Col span={10}>Nomor Rangka</Col>
            <Col span={14}>:&nbsp;{dataOrder.vehicle_chassis_number}</Col>
          </Row>
          <Row>
            <Col span={10}>Variant Kendaraan</Col>
            <Col span={14}>:&nbsp;{dataOrder.vehicle_variant_name}</Col>
          </Row>
          <Row>
            <Col span={10}>Kode Samsat</Col>
            <Col span={14}>:&nbsp;{dataOrder.samsat_code}</Col>
          </Row>
          <br />
          <Row>
            <Col span={10}>Lunas Leasing</Col>
            <Col span={14}>
              :&nbsp;<strong>{dataOrder.transfer_title_null ? dataOrder.flag_has_outstanding : "FALSE"}</strong>
            </Col>
          </Row>
          <Row>
            <Col span={10}>BBN Kosong</Col>
            <Col span={14}>
              :&nbsp;<strong>{dataOrder.transfer_title_null ? dataOrder.transfer_title_null : "FALSE"}</strong>
            </Col>
          </Row>
        </Col>
        <Col xl={{ span: 9 }} lg={{ span: 9 }} md={{ span: 9 }} sm={{ span: 24 }} xs={{ span: 24 }}>
          <Row>
            <Col span={10}>Status BBN</Col>
            <Col span={14}>
              :&nbsp;<strong>{dataOrder.transfer_title_status}</strong>
            </Col>
          </Row>
          {tglPenugasan.isAfter(cutOffNotice) && (
            <Row>
              <Col span={10}>Notice Approved</Col>
              <Col span={14}>
                :&nbsp;<strong>{dataOrder.payment_approved ? dataOrder.payment_approved : "FALSE"}</strong>
              </Col>
            </Row>
          )}
          <br />
          <Row>
            <Col span={10}>Biaya Notice</Col>
            <Col span={14}>
              :&nbsp;<strong>{dataOrder?.notice_cost?.toLocaleString()}</strong>
            </Col>
          </Row>
          <Row>
            <Col span={10}>Biaya Proses</Col>
            <Col span={14}>
              :&nbsp;<strong>{dataOrder?.process_cost?.toLocaleString()}</strong>
            </Col>
          </Row>
          <Row>
            <Col span={10}>Biaya PKB</Col>
            <Col span={14}>
              :&nbsp;<strong>{dataOrder?.pkb_cost?.toLocaleString()}</strong>
            </Col>
          </Row>
          <Row>
            <Col span={10}>Biaya Progresif</Col>
            <Col span={14}>
              :&nbsp;<strong>{dataOrder?.progressive_cost?.toLocaleString()}</strong>
            </Col>
          </Row>
          <Row>
            <Col span={10}>Biaya Jasa</Col>
            <Col span={14}>
              :&nbsp;<strong>{dataOrder?.service_cost?.toLocaleString()}</strong>
            </Col>
          </Row>
          <Row>
            <Col span={10}>Total BBN</Col>
            <Col span={14}>
              :&nbsp;<strong>{dataOrder?.transfer_title_cost?.toLocaleString()}</strong>
            </Col>
          </Row>
        </Col>
      </Row>

      <br />
      <br />
      {/* Steps */}
      <Steps direction="vertical" size="small" current={currentStep}>
        {(allSteps || []).map((step, index) => (
          <Step
            key={index}
            title={
              <div>
                <Text strong>{step.title}</Text>
              </div>
            }
            description={
              <div>
                {currentStep >= index && (
                  <>
                    {step.timestamp && step.timestamp !== "NONE" && (
                      <>
                        <Text>{step.timestamp}</Text>
                        <br />
                      </>
                    )}
                    <Text type="secondary" style={{ fontSize: 12 }}>
                      {step.description}
                    </Text>
                  </>
                )}
              </div>
            }
          />
        ))}
      </Steps>
    </Card>
  );
};

export default TrackingData;
